import { saveUserSessionData, getLabelTypeForSession } from "./CheckSession";
import { getSessionObjectId } from "./indexHelper";
import { sessionCache } from "./sessionCache";
import {
  CatalogueTable,
  Quantity,
  Table as TableType,
  FibreList,
  requestOptions as globalRequestOptions,
} from "../Constants/GlobalConstant";
import { callOCCProfileAPI } from "./callOCCAPI";
import { RedirectToSourceLoginIfSessionExpired } from "./CheckSession";
import { parseJSON } from "date-fns";
import { GetSystemParameterValueByNameTextFormat } from "./SchemaAPICalls";
export const CreateVIPSVarOrderDetailItemObject2 = (
  key,
  value,
  line,
  VIPSVarOrderDetailItems,
  variable_desc,
  tableIndex,
  pageId
) => {
  //if (value?.length > 0) {
  const VIPSVarOrderDetailItem = {
    variable_id: key + line,
    variable_text: value,
    variable_desc: variable_desc,
    variable_webId: `INQ_${pageId}_${key}`,
    field_id: "",
    additionalVar2_Data: "",
  };
  if (tableIndex)
    VIPSVarOrderDetailItem.variable_webId =
      VIPSVarOrderDetailItem.variable_webId + "_" + tableIndex;
  VIPSVarOrderDetailItems.push(VIPSVarOrderDetailItem);
  //}
};
let multiSelectCount = 0;
export const CreateVIPSVarOrderDetailItemObject = (
  schema,
  value,
  line,
  VIPSVarOrderDetailItems,
  variable_desc,
  tableIndex
) => {
    //if (value?.length > 0) {
  if (schema.multiSelect) {
    value = value[multiSelectCount];
    multiSelectCount = multiSelectCount + 1;
  }
  const VIPSVarOrderDetailItem = {
    variable_id: schema.tagName + line,
    variable_text: value,
    variable_desc: variable_desc,
    variable_webId: `${schema.prefix}_${schema.pageId}_${schema.tagName}`,
    field_id: schema.fieldId ?? "",
    additionalVar2_Data: "",
  };
  if (tableIndex)
    VIPSVarOrderDetailItem.variable_webId =
      VIPSVarOrderDetailItem.variable_webId + "_" + tableIndex;
  VIPSVarOrderDetailItems.push(VIPSVarOrderDetailItem);
  //}
};

export async function SaveLocalStorageInSession(user_id, jsonObjectId, isSourceOCC) {
  var saveUser = "SU" + jsonObjectId + user_id + "saveUser";
  var saveSchemaObject = "SO" + jsonObjectId + user_id + "saveSchemaObject";
  var userOEForm = user_id + jsonObjectId + "userOEForm";
  var checkoutForm = user_id + jsonObjectId + "checkoutForm";
  var autocomplete = user_id + jsonObjectId + "autocomplete";
  var multiSelectLabelItem = user_id + jsonObjectId + "multiSelectLabelItem";
  var uniqueLabelRef1 = user_id + jsonObjectId + "uniqueLabelRef1";
  var firstPageId = "firstPageID";

  const filteredData = sessionCache.toFilteredObject([
    saveUser,
    saveSchemaObject,
    userOEForm,
    checkoutForm,
    autocomplete,
    multiSelectLabelItem,
    uniqueLabelRef1,
    firstPageId,
  ]);
  await saveUserSessionData(user_id, jsonObjectId, isSourceOCC ? sessionCache.toObject() : filteredData);
}

export const getQuantity = (schema, usr, schemaObject1) => {
  const quantityResults = checkQuantityFieldName(schemaObject1);
  const [quantityFieldName, tableName2] = quantityResults;
  var sumqty2 = 0;

  const quantityResults2 = checkQuantityFieldName2(schema);
  if (usr !== undefined) {
    sumqty2 = 0;
    const [quantityFieldName2, tableName] = quantityResults2;
    if (quantityFieldName?.length > 0) {
      if (typeof usr[quantityFieldName2] === "string") {
        sumqty2 += parseInt(usr[quantityFieldName2]);
      } else if (typeof usr[tableName] === "object") {
        usr[tableName]?.forEach((x) => {
          if (x[quantityFieldName2]?.length > 0) {
            sumqty2 += parseInt(x[quantityFieldName2]);
          }
        });
      }

      return sumqty2;
    }
    return 0;
  }
};

export const checkQuantityFieldName2 = (schemaObject) => {
  let quantityFieldName = "";
  let quantityFieldNameData;
  if (schemaObject !== undefined) {
    quantityFieldName = schemaObject.find(
      (x) => x.schemaType === 16
    )?.fieldName;
    if (quantityFieldName?.length > 0) {
      return [quantityFieldName];
    }

    const tables = schemaObject.filter(
      (x) => x.dataType === TableType || x.dataType === CatalogueTable
    );
    for (const table of tables) {
      quantityFieldNameData = table.schemaPageSubItems.find(
        (x) => x.dataType === Quantity || x.catalogueSchemaType === 16
      );
      if (quantityFieldNameData) {
        return [quantityFieldNameData.fieldName, table.fieldName];
      }
    }
  }
  return [quantityFieldName];
};

export const checkQuantityFieldName = (schemaObject) => {

  let quantityFieldName = "";

  for (let ind = 0; ind < schemaObject.length; ind++) {
    let quantityFieldNameData;
    quantityFieldName = schemaObject[ind].find(
      (x) => x.schemaType === 16
    )?.fieldName;
    if (quantityFieldName?.length > 0) {
      return [quantityFieldName];
    }
    const tables = schemaObject[ind].filter(
      (x) => x.dataType === TableType || x.dataType === CatalogueTable
    );
    for (const table of tables) {
      quantityFieldNameData = table.schemaPageSubItems.find(
        (x) => x.dataType === Quantity || x.catalogueSchemaType === 16
      );
      if (quantityFieldNameData) {
        return [quantityFieldNameData.fieldName, table.fieldName];
      }
    }
  }
  return [quantityFieldName];
};

// Find the label reference field inside a table by tagName 'LABELREF' (or fallback to prefix)
export const checkLabelRefFieldName = (schemaObject, labPrefix) => {
  let labelFieldName = "";
  let tableName = undefined;
  for (let ind = 0; ind < schemaObject.length; ind++) {
    const tables = schemaObject[ind].filter(
      (x) =>
        x.dataType === TableType ||
        x.dataType === CatalogueTable ||
        x.prefix === "TAB" ||
        x.prefix === "CTB"
    );
    for (const table of tables) {
      const subItems = Array.isArray(table.schemaPageSubItems)
        ? table.schemaPageSubItems
        : [];
      const labelField = subItems.find(
        (x) => x.tagName === "LABELREF" || x.tagName==="LABEL" || (labPrefix && x.prefix === labPrefix)
      );
      if (labelField) {
        labelFieldName = labelField.fieldName;
        tableName = table.fieldName;
        return [labelFieldName, tableName];
      }
    }
  }
  return [labelFieldName, tableName];
};

export const processPost = (post) => {
  let user_id = "";
  let labelSessionArray = [];
  let divisionId = "";

  let DivDesc = "";
  let schema_id = "";
  let store_grp = "";
  let customer_id = "";
  let varlength = "";
  let labelRef = "";
  let usre_type = "";
  let store_grp_desc = "";
  let schema_name = "";
  let occ_profile = "";
  let prod_loc_occ = "";
  let user_source = "VIPS";

  if (typeof post.post !== "undefined") {
    const SessionArray = post.post.paxWebSessionStrings;
    SessionArray.forEach(function (item) {
      if (item.Key == "user_type") {
        usre_type = item.Value;
      }
      if (item.Key == "division_id") {
        divisionId = item.Value;
      }
      if (item.Key == "user_id") {
        user_id = item.Value;
      }
      if (item.Key == "DivDesc") {
        DivDesc = item.Value;
      }
      if (item.Key == "schema_id") {
        schema_id = item.Value;
      }
      if (item.Key == "store_grp") {
        store_grp = item.Value;
      }
      if (item.Key == "acc_no") {
        customer_id = item.Value;
      }
      if (item.Key == "store_grp_desc") {
        store_grp_desc = item.Value;
      }
      if (item.Key == "schema_name") {
        schema_name = item.Value;
      }
      if (item.Key == "user_source") {
        user_source = item.Value;
      }
      if (item.Key == "LabelList") {
        const jsonData = JSON.parse(item.Value);

        const occLabelList = jsonData.OCCLabelList;
        schema_name = jsonData.SchemaName;
        occ_profile = jsonData.OccProfile;
        prod_loc_occ = jsonData.OccProdLocation;
        const distinctValues = [
          ...new Set(occLabelList.map((item) => item.LabelReference)),
        ];
        labelSessionArray = distinctValues;
      }
    });
  }

  return {
    user_id,
    labelSessionArray,
    divisionId,
    DivDesc,
    schema_id,
    store_grp,
    customer_id,
    varlength,
    labelRef,
    usre_type,
    store_grp_desc,
    schema_name,
    occ_profile,
    prod_loc_occ,
    user_source,
  };
};

export const navigateToPath = (
  searchParams,
  SessionArray,
  labelSessionArray,
  navigate,
  firstPageID,
  labelsWithVariableData,
  store_grp_desc,
  user_id
) => {
  let schema_id = "";
  let store_grp = "";
  let divisionId = "";

  SessionArray.forEach(function (item) {
    if (item.Key === "division_id") {
      divisionId = item.Value;
    }

    if (item.Key === "schema_id") {
      schema_id = item.Value;
    }
    if (item.Key === "store_grp") {
      store_grp = item.Value;
    }
  });

  let searchParamsString = `&session_id=${searchParams.get(
    "session_id"
  )}&PageID=${firstPageID}&schema_id=${schema_id}&store_grp=${store_grp}&store_grp_desc=${store_grp_desc}&vd_mode=${searchParams.get(
    "vd_mode"
  )}`;

  if (searchParams.get("OCC")) {
    const saveLabelSessionValue = JSON.parse(
      localStorage.getItem(user_id + "saveLabelSession")
    );

    navigate({
      pathname: `/${process.env.REACT_APP_ORDERING_PATH}`,
      search: `${searchParamsString}&label=${labelsWithVariableData[0]}&&OCC=True&vipsOrder=Inprogress`,
    });
  } else {
    navigate({
      pathname: `/${process.env.REACT_APP_ORDERING_PATH}`,
      search:
        `${searchParamsString}${
          searchParams.get("OrderID") !== null
            ? `&OrderID=${searchParams.get("OrderID")}`
            : ""
        }&Amend=True` +
        (searchParams.get("SelectedDivision") ? `&SelectedDivision=${searchParams.get("SelectedDivision")}` : ""),
    });
  }
};

export const navigateToConfirmOrder = (
  searchParams,
  data,
  OrderList,
  schema_id,
  store_grp,
  store_grp_desc,
  navigate,
  prod_loc_occ,
  occ_profile,
  schema_name,
  divisionId
) => {
  let searchParamsString = `&session_id=${searchParams.get(
    "session_id"
  )}&OrderID=`;
  let OCCParam = "";
  const divParam = divisionId ? `&SelectedDivision=${divisionId}` : "";

  if (searchParams.get("OCC")) {
    OCCParam = "&OCC=True";
    callOCCProfileAPI(false, prod_loc_occ, occ_profile, schema_name).then(
      (res) => {
        navigate({
          pathname: `/${process.env.REACT_APP_ORDERING_PATH}/ConfirmOrder`,
          search: `${searchParamsString}${
            data.Order[0].order_id
          }&schema_id=${schema_id}&store_grp=${store_grp}&store_grp_desc=${store_grp_desc}&vd_mode=${searchParams.get(
            "vd_mode"
          )}${OCCParam}${divParam}`,
        });
      }
    );
  } else {
    navigate({
      pathname: `/${process.env.REACT_APP_ORDERING_PATH}/ConfirmOrder`,
      search: `${searchParamsString}${OrderList.join(
        "|"
      )}&schema_id=${schema_id}&store_grp=${store_grp}&store_grp_desc=${store_grp_desc}&vd_mode=${searchParams.get(
        "vd_mode"
      )}${OCCParam}${divParam}`,
    });
  }
};
export function findDistincPOAndLabel(array, PONumber, LabelReference) {
  const distinctValues = new Set();
  array.forEach((item) => {
    if (
      item.hasOwnProperty(PONumber) &&
      item.hasOwnProperty(LabelReference) &&
      item[PONumber] !== "" &&
      item[LabelReference] !== ""
    ) {
      const combinedKey = item[PONumber] + "_" + item[LabelReference];
      distinctValues.add(combinedKey);
    }
  });
  return Array.from(distinctValues).map((combinedKey) => {
    const [orderNumber, brand] = combinedKey.split("_");
    return { PONumber: orderNumber, LabelReference: brand };
  });
}

export function findDistinctValues(array, key) {
  const distinctValues = new Set();
  array.forEach((item) => {
    if (item.hasOwnProperty(key) && item[key] !== "") {
      distinctValues.add(item[key]);
    }
  });
  return Array.from(distinctValues);
}

export function saveCheckoutForm(
  DefaultDelivery,
  DeliveryAddress,
  DelAddress1,
  DelAddress4,
  DelAddress2,
  DelAddress3,
  DelPostalCode,
  DelCustomerName,
  DelContactName,
  DelCountry,
  custPoNumber,
  selectedCarriers,
  selectedFreightTerms,
  SpecialInstruction,
  PrinterNotes,
  VendorNotes,
  shippingInstruction,
  orderLineInstructions,
  retailerPurchaseOrderNo,
  shippingMark,
  samplingAndPackagingCode,
  customerId,
  DeLAddressDrop,
  shipToID,
  user_id,
  searchParams,
  requestNewAddress
) {
  const data = {
    DefaultDelivery,
    DeliveryAddress,
    DelAddress1,
    DelAddress4,
    DelAddress2,
    DelAddress3,
    DelPostalCode,
    DelCustomerName,
    DelContactName,
    DelCountry,
    custPoNumber,
    selectedCarriers,
    selectedFreightTerms,
    SpecialInstruction,
    PrinterNotes,
    VendorNotes,
    shippingInstruction,
    orderLineInstructions,
    retailerPurchaseOrderNo,
    shippingMark,
    samplingAndPackagingCode,
    customerId,
    DeLAddressDrop,
    shipToID,
    requestNewAddress,
  };
// FIX: fallback to PageID when firstPageID not set so tests locate correct key
  let firstPageID = null;
  try {
    const raw = localStorage.getItem("firstPageID");
firstPageID = raw ? JSON.parse(raw) : null;
  } catch (_) {
    firstPageID = null;
  }
  const jsonObjectId = searchParams.get("OCC")
    ? searchParams.get("PageID")
    : (firstPageID ?? searchParams.get("PageID"));
  sessionCache.set(user_id + jsonObjectId + "checkoutForm", data);
}

export async function handleOrderSubmit({
  e,
  CheckCollector,
  CollectorName,
  setcollectorNamevalidation,
  childComponentRef,
  additionalInformationComponentRef,
  csvUplaodEnabled,
  jsonData,
  newtempArr,
  Order,
  user_source,
  divisionId,
  user_id,
  store_grp,
  PrinterNotes,
  orderLineInstructions,
  VendorNotes,
  retailerPurchaseOrderNo,
  SpecialInstruction,
  shippingInstruction,
  schema_id,
  requiredDate,
  customerId,
  customerRequestDate,
  promiseDate,
  customerOrderDate,
  selectedFreightTerms,
  selectedCarriers,
  samplingAndPackagingCode,
  shippingMark,
  orderOnHold,
  layoutApproval,
  CreateVIPSOrderDetailsItemForCSVUpload,
  CreateVIPSVarOrderHeaderItemForCSVUpload,
  CreateVIPSOrderDetailsItem,
  CreateVIPSVarOrderHeaderItem,
  LabelSession,
  LabPrefix,
  schemaObject,
  user,
  custPoNumber,
  setIsLoading,
  RedirectToSourceLoginIfSessionExpired,
  searchParams,
  getMessage,
  URL,
  navigateToConfirmOrder,
  prod_loc_occ,
  occ_profile,
  schema_name,
  store_grp_desc,
  navigate,
  deleteUserSessionData,
  deleteUserLabelSessionData,
  priorityRequired = false,
  setSnackbarMessage,
  setOpenSnackbar,
}) {
  // e.preventDefault();
  let inValidFlag = false;
  if ((CheckCollector && CollectorName === "") || CollectorName === undefined) {
    setcollectorNamevalidation({
      msg: "Please Enter Collector Name",
      inValid: true,
    });
    inValidFlag = true;
  }
  if (
    inValidFlag ||
    childComponentRef.current.validateForm() ||
    additionalInformationComponentRef.current.validateForm()
  ) {
    return;
  }

  setIsLoading(true);

  // --- Factory/Division config overrides ---
  let fdConfig = null;
  try {
    fdConfig = JSON.parse(localStorage.getItem("factoryDivisionConfig"));
  } catch (_) {}
  // Override divisionId from factory config when available
  const effectiveDivision = fdConfig
    ? (getFactoryConfigCustDiv(user_id, searchParams, LabelSession?.LabelSession || [])?.divisionId || divisionId)
    : divisionId;

  // --- IsLabelRefConfigured validation before order creation ---
  try {
    if (store_grp && effectiveDivision && newtempArr.length > 0) {
      const labelRefs = [
        ...new Set(
          newtempArr
            .map((item) => item.ProductDesc)
            .filter((desc) => typeof desc === "string" && desc.trim() !== "")
        ),
      ];
      if (labelRefs.length > 0) {
        const results = await Promise.all(
          labelRefs.map(async (lr) => {
            const url = `${URL}/Product/IsLabelRefConfigured?storeGroup=${encodeURIComponent(store_grp)}&labelRef=${encodeURIComponent(lr)}&divisionId=${encodeURIComponent(effectiveDivision)}`;
            const resp = await fetch(url, globalRequestOptions);
            const ok = await resp.json();
            return { lr, ok: !!ok };
          })
        );
        const invalidLabels = results.filter((r) => r.ok === false).map((r) => r.lr);
        if (invalidLabels.length > 0) {
          const msg = getMessage
            ? getMessage("labelOrderingClosed")
            : "Ordering closed";
          const finalMsg = typeof msg === "string"
            ? msg.replace("{Label}", invalidLabels.join(", ")).replace("{DivisionId}", effectiveDivision)
            : "Ordering closed";
          if (setSnackbarMessage && setOpenSnackbar) {
            setSnackbarMessage(finalMsg);
            setOpenSnackbar(true);
          } else {
            alert(finalMsg);
          }
          setIsLoading(false);
          return;
        }
      }
    }
  } catch (_e) {
    // On error, do not block order submission
  }

  // Compute total quantity across all order lines
  const totalQty = newtempArr.reduce((sum, item) => sum + (parseInt(item.Quantity) || 0), 0);

  if (csvUplaodEnabled) {
    jsonData.Order = [];
    newtempArr.forEach((value, index) => {
      const newOrder = { ...Order };
      newOrder.ordersource = user_source;
      newOrder.collect_order = CheckCollector;
      newOrder.division_id = effectiveDivision;
      newOrder.user_id = user_id;
      newOrder.store_grp = store_grp;
      newOrder.printer_notes = PrinterNotes;
      newOrder.order_line_instructions = orderLineInstructions;
      newOrder.vendor_notes = VendorNotes;
      newOrder.rbo_pono = retailerPurchaseOrderNo;
      newOrder.spec_instr =
        priorityRequired && SpecialInstruction
          ? `Customer Reference: ${SpecialInstruction}`
          : SpecialInstruction;
      newOrder.shipping_instructions = shippingInstruction;
      newOrder.schema_id = schema_id;
      // Harmonize with non-CSV path: use UTC midnight date-only
      newOrder.requestDate = toUTCDateOnly(requiredDate);
      newOrder.createdDate = new Date();
      newOrder.customer_PO = value.PO; //custPoNumber;
      //newOrder.RequiredDate = requiredDate;
      newOrder.orderedBy = user_id;
      newOrder.customer_id = customerId;
      // Preserve null when not set; otherwise send UTC date-only string
      newOrder.customer_request_date = customerRequestDate
        ? toUTCDateOnly(customerRequestDate)
        : null;
      newOrder.promise_date = promiseDate ? toUTCDateOnly(promiseDate) : null;
      newOrder.customer_order_date = customerOrderDate;
      newOrder.freight_term = selectedFreightTerms;
      newOrder.carrier_code = selectedCarriers !== "" ? selectedCarriers : 0;
      newOrder.spCode = samplingAndPackagingCode;
      newOrder.ship_mark = shippingMark;
      newOrder.on_hold = orderOnHold ? "Y" : "N";
      newOrder.generate_layout = layoutApproval ? "Y" : "N";
      // Use selected priority from caller (fallback to 1)
      newOrder.priority_id = Order?.priority_id ? Order.priority_id : -1;
      if (newOrder.collect_order == false) {
        newOrder.collector_name = "";
      } else {
        newOrder.collector_name = CollectorName;
      }
      newOrder.VIPSOrderDetailItem = CreateVIPSOrderDetailsItemForCSVUpload(
        value,
        schemaObject,
        user,
        LabelSession,
        LabPrefix
      );
      newOrder.VIPSVarOrderHeaderItem =
        CreateVIPSVarOrderHeaderItemForCSVUpload(value, schemaObject, user);
      jsonData.Order.push(newOrder);
    });
  } else {
    jsonData.Order = [];
    const newOrder = { ...Order };
    newOrder.CopyOrderId = searchParams.get("OrderID") || "";
    newOrder.ordersource = user_source;
    newOrder.collect_order = CheckCollector;
    newOrder.division_id = effectiveDivision;
    newOrder.user_id = user_id;
    newOrder.store_grp = store_grp;
    newOrder.printer_notes = PrinterNotes;
    newOrder.order_line_instructions = orderLineInstructions;
    newOrder.vendor_notes = VendorNotes;
    newOrder.rbo_pono = retailerPurchaseOrderNo;
    newOrder.spec_instr =
      priorityRequired && SpecialInstruction
        ? `Customer Reference: ${SpecialInstruction}`
        : SpecialInstruction;
    newOrder.shipping_instructions = shippingInstruction;
    newOrder.schema_id = schema_id;
    newOrder.requestDate =  toUTCDateOnly(requiredDate);
    newOrder.createdDate = new Date();
    newOrder.customer_PO = custPoNumber;
    //newOrder.RequiredDate = requiredDate;
    newOrder.orderedBy = user_id;
    newOrder.customer_id = customerId;
    // Preserve nulls when dates are intentionally hidden/unset
    newOrder.customer_request_date = customerRequestDate
      ? toUTCDateOnly(customerRequestDate)
      : null;
    newOrder.promise_date = promiseDate ? toUTCDateOnly(promiseDate) : null;
    newOrder.customer_order_date = customerOrderDate;
    newOrder.freight_term = selectedFreightTerms;
    newOrder.carrier_code = selectedCarriers !== "" ? selectedCarriers : 0;
    newOrder.spCode = samplingAndPackagingCode;
    newOrder.ship_mark = shippingMark;
    newOrder.on_hold = orderOnHold ? "Y" : "N";
    newOrder.generate_layout = layoutApproval ? "Y" : "N";
    // Use selected priority from caller (fallback to 1)
    newOrder.priority_id = Order?.priority_id ? Order.priority_id : -1;
    if (newOrder.collect_order == false) {
      newOrder.collector_name = "";
    } else {
      newOrder.collector_name = CollectorName;
    }
    newOrder.VIPSOrderDetailItem = CreateVIPSOrderDetailsItem(
      newtempArr,
      schemaObject,
      user,
      LabPrefix,
      LabelSession
    );
    newOrder.VIPSVarOrderHeaderItem = CreateVIPSVarOrderHeaderItem(
      schemaObject,
      user
    );
    jsonData.Order.push(newOrder);
  }
  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: "Basic T0VGb3JtVXNlcjpBdmVyeUAxMjM0NQ==",
      ReactApiKey: process.env.REACT_APP_API_KEY,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(jsonData),
  };
  RedirectToSourceLoginIfSessionExpired(
    user_id,
    searchParams.get("session_id"),
    searchParams.get("OCC"),
    true
  );
  fetch(`${URL}` + `/Order/ConfirmOrder`, requestOptions)
    .then((response) => response.json())
    .then((data) => {
      if (data.Order[0].order_id != "") {
        var OrderList = [];
        data.Order.forEach((value, index) => {
          OrderList.push(value.order_id);
        });
        var myItem = localStorage.getItem("sessionArray");
        var firstPageID = JSON.parse(localStorage.getItem("firstPageID"));
        // Collect all unique session IDs from SO/SU localStorage keys before clearing.
// Data is saved under PageIDs (not label names), so we must delete by PageID.
        var sessionIdsToDelete = new Set();
        if (firstPageID) sessionIdsToDelete.add(String(firstPageID));
        var soSuffix = user_id + "saveSchemaObject";
        var suSuffix = user_id + "saveUser";
        for (const cacheKey of sessionCache.keys()) {
          if (cacheKey.startsWith("SO") && cacheKey.endsWith(soSuffix)) {
            var soId = cacheKey.slice(2, cacheKey.length - soSuffix.length);
            if (soId) sessionIdsToDelete.add(soId);
          } else if (cacheKey.startsWith("SU") && cacheKey.endsWith(suSuffix)) {
            var suId = cacheKey.slice(2, cacheKey.length - suSuffix.length);
            if (suId) sessionIdsToDelete.add(suId);
          }
        }
        for (var k = 0; k < localStorage.length; k++) {
          var lsKey = localStorage.key(k);
          if (lsKey.startsWith("SO") && lsKey.endsWith(soSuffix)) {
            var soId = lsKey.slice(2, lsKey.length - soSuffix.length);
            if (soId) sessionIdsToDelete.add(soId);
          } else if (lsKey.startsWith("SU") && lsKey.endsWith(suSuffix)) {
            var suId = lsKey.slice(2, lsKey.length - suSuffix.length);
            if (suId) sessionIdsToDelete.add(suId);
          }
        }
        localStorage.clear();
        sessionCache.clear();
        localStorage.setItem("sessionArray", myItem);
        sessionIdsToDelete.forEach(function(id) {
          deleteUserSessionData(user_id, id);
        });
        var jsonObjectId = "LabelList";
        deleteUserLabelSessionData(user_id, jsonObjectId);

        navigateToConfirmOrder(
          searchParams,
          data,
          OrderList,
          schema_id,
          store_grp,
          store_grp_desc,
          navigate,
          prod_loc_occ,
          occ_profile,
          schema_name,
          effectiveDivision
        );
      }
    })
    .catch((err) => {
      alert(getMessage("error"));
      setIsLoading(false);
    });
}

/**
 * Reads the division selected on the ordering page via the FACTORY/DIVISION
 * config (REACT_APP_FACTORY_DIVISION_SCHEMAS).  Returns an object
 * { customerId, divisionId } or null when no config / saved value is found.
 */
export function getFactoryConfigCustDiv(user_id, searchParams, labelSessionArray) {
  try {
    const fdConfig = JSON.parse(localStorage.getItem("factoryDivisionConfig"));
    const divisionTagName = fdConfig?.divisionTagName;
    if (!divisionTagName) return null;

    // Determine SO/SU key prefix (session object id)
    const sessionObjId = getSessionObjectId(searchParams, labelSessionArray);
    const soKey = "SO" + sessionObjId + user_id + "saveSchemaObject";
    const suKey = "SU" + sessionObjId + user_id + "saveUser";

    const schemaPages = sessionCache.get(soKey) ?? null;
    const userData = sessionCache.get(suKey) ?? null;
    if (!schemaPages || !userData) return null;

    // schemaPages is [ [fields…], [fields…] ] – flatten to search all pages
    const allFields = Array.isArray(schemaPages[0])
      ? schemaPages.flat()
      : schemaPages;

    const divField = allFields.find(
      (f) => f && f.tagName === divisionTagName && f.prefix === "SLI"
    );
    if (!divField) return null;

    const rawValue = userData[divField.fieldName];
    if (!rawValue || typeof rawValue !== "string") return null;

    // Value is in CustDiv format "CustomerId||DivisionId"
    const parts = rawValue.split("||");
    if (parts.length > 1) {
      return { customerId: parts[0].trim(), divisionId: parts[1].trim() };
    }
    return { customerId: "", divisionId: rawValue.trim() };
  } catch (_) {
    return null;
  }
}

/**
 * Convenience wrapper – returns only the division ID string or null.
 */
export function getDivisionFromFactoryConfig(user_id, searchParams, labelSessionArray) {
  return getFactoryConfigCustDiv(user_id, searchParams, labelSessionArray)?.divisionId || null;
}

export function GetRequesteDate(
  tempArr,
  {
    divisionId,
    store_grp,
    setIsLoading,
    alert,
    getMessage,
    setDisableDateSelection,
    setMinimumDate,
    SetRequiredDate,
    setCustomerRequestDate,
    setPromiseDate,
    setCustomerOrderDate,
    GetRequesteDateAPI,
    lockDates,
    priorityId,
    setSnackbarMessage,
    setOpenSnackbar,
  }
) {
  let date = null;
  setIsLoading(true);
  if (tempArr.length <= 0) {
          alert(getMessage("atLeastOneLabel"));
        setDisableDateSelection(true);
    setIsLoading(false);
  } else {
    const failedLabels = [];
    const promises = tempArr.map((x) =>
      // Always send priorityId; use -1 fallback to match server default
      GetRequesteDateAPI(
        divisionId,
        x.ProductDesc,
        store_grp,
        priorityId ?? -1
      ).then(
        (requestDate) => {
          if (requestDate && !isNaN(new Date(requestDate).getTime())) {
            if (!date || new Date(requestDate) > new Date(date)) {
              date = requestDate;
            }
          } else {
            failedLabels.push(x.ProductDesc);
          }
          return requestDate;
        }
      ).catch(() => {
        failedLabels.push(x.ProductDesc);
        return null;
      })
    );
    Promise.all(promises).then(() => {
      if (failedLabels.length > 0 && setSnackbarMessage && setOpenSnackbar) {
        const msg = getMessage("labelNotSetupInDivision")
          .replace("{Label}", failedLabels.join(", "))
          .replace("{DivisionId}", divisionId);
        setSnackbarMessage(msg);
        setOpenSnackbar(true);
      }
      if (date) {
        // Always set required date from API result (max date across labels)
        SetRequiredDate(date);
        // When priority is NOT required, also gate and set related dates
        if (!lockDates) {
          setMinimumDate(date);
          setCustomerRequestDate(date);
          setPromiseDate(date);
        } else {
          // When priority is required, do not restrict via minimumDate
          // and clear API-driven customer/promise dates
          setCustomerRequestDate(null);
          setPromiseDate(null);
        }
        // Always set customer order date to current date-time
        setCustomerOrderDate(new Date());
      }
      setIsLoading(false);
    });
  }
}

export function cancelOrder(
  user_id,
  searchParams,
  deleteUserSessionData,
  deleteUserLabelSessionData,
  callOCCProfileAPI,
  prod_loc_occ,
  occ_profile,
  schema_name
) {
  const sessionObjId = getSessionObjectId(searchParams);
  localStorage.clear();
  sessionCache.clear();
  deleteUserSessionData(
    user_id,
    sessionObjId
  );
  var jsonObjectId = "LabelList";
  deleteUserLabelSessionData(user_id, jsonObjectId);
  callOCCProfileAPI(false, prod_loc_occ, occ_profile, schema_name).then(
    (res) => {
      var path = process.env.REACT_APP_OCC_ORDER_ABORTED_URL;
      window.location.href = path;
    }
  );
}

export function RedirectBackToOCC({
  user_id,
  searchParams,
  DefaultDelivery,
  selectedDelivery,
  DelAddress1,
  DelAddress4,
  DelAddress2,
  DelAddress3,
  DelPostalCode,
  DelCustomerName,
  DelContactName,
  DelCountry,
  custPoNumber,
  selectedCarriers,
  selectedFreightTerms,
  SpecialInstruction,
  PrinterNotes,
  VendorNotes,
  shippingInstruction,
  orderLineInstructions,
  retailerPurchaseOrderNo,
  shippingMark,
  samplingAndPackagingCode,
  customerId,
  DeLAddressDrop,
  shipToID,
  requestNewAddress,
  RedirectToSourceLoginIfSessionExpired,
  saveCheckoutForm,
  SaveLocalStorageInSession,
}) {
  RedirectToSourceLoginIfSessionExpired(
    user_id,
    searchParams.get("session_id"),
    searchParams.get("OCC"),
    true
  );
  saveCheckoutForm(
    DefaultDelivery,
    selectedDelivery,
    DelAddress1,
    DelAddress4,
    DelAddress2,
    DelAddress3,
    DelPostalCode,
    DelCustomerName,
    DelContactName,
    DelCountry,
    custPoNumber,
    selectedCarriers,
    selectedFreightTerms,
    SpecialInstruction,
    PrinterNotes,
    VendorNotes,
    shippingInstruction,
    orderLineInstructions,
    retailerPurchaseOrderNo,
    shippingMark,
    samplingAndPackagingCode,
    customerId,
    DeLAddressDrop,
        DefaultDelivery,
    user_id,
    searchParams,
    requestNewAddress
  );
  SaveLocalStorageInSession(
    user_id,
     getSessionObjectId(searchParams),
    searchParams.get("OCC") ? true : false
  );
  if (searchParams.get("vipsOrder")) {
    var path = process.env.REACT_APP_OCC_ORDER_INPROGRESS_URL;
    window.location.href = path;
  } else {
    var path = process.env.REACT_APP_OCC_URL;
    window.location.href = path;
  }
}

export function RedirectClick({
  user_id,
  searchParams,
  DefaultDelivery,
  selectedDelivery,
  DelAddress1,
  DelAddress4,
  DelAddress2,
  DelAddress3,
  DelPostalCode,
  DelCustomerName,
  DelContactName,
  DelCountry,
  custPoNumber,
  selectedCarriers,
  selectedFreightTerms,
  SpecialInstruction,
  PrinterNotes,
  VendorNotes,
  shippingInstruction,
  orderLineInstructions,
  retailerPurchaseOrderNo,
  shippingMark,
  samplingAndPackagingCode,
  customerId,
  DeLAddressDrop,
  shipToID,
  requestNewAddress,
  saveCheckoutForm,
  SaveLocalStorageInSession,
  navigateToPath,
  SessionArray,
  labelSessionArray,
  navigate,
  labelsWithVariableData,
  store_grp_desc,
}) {
  RedirectToSourceLoginIfSessionExpired(
    user_id,
    searchParams.get("session_id"),
    searchParams.get("OCC"),
    true
  );
  saveCheckoutForm(
    DefaultDelivery,
    selectedDelivery,
    DelAddress1,
    DelAddress4,
    DelAddress2,
    DelAddress3,
    DelPostalCode,
    DelCustomerName,
    DelContactName,
    DelCountry,
    custPoNumber,
    selectedCarriers,
    selectedFreightTerms,
    SpecialInstruction,
    PrinterNotes,
    VendorNotes,
    shippingInstruction,
    orderLineInstructions,
    retailerPurchaseOrderNo,
    shippingMark,
    samplingAndPackagingCode,
    customerId,
    DeLAddressDrop,
    DefaultDelivery,
    user_id,
    searchParams,
    requestNewAddress
  );
  const firstPageID = JSON.parse(localStorage.getItem("firstPageID"));
  var Promise = SaveLocalStorageInSession(
    user_id,
    searchParams.get("OCC") ? getSessionObjectId(searchParams, labelSessionArray) : firstPageID,
    searchParams.get("OCC") ? true : false
  );

  Promise.then((response) => {
    navigateToPath(
      searchParams,
      SessionArray,
      labelSessionArray,
      navigate,
      firstPageID,
      labelsWithVariableData,
      store_grp_desc,
      user_id
    );
  });
}

export async function fetchUserSessionData({
  user_id,
  searchParams,
  labelSessionArray,
  LabelSession2,
  setLabelSession,
  setSchemaObject,
  setUser,
  setNewtempArr,
  setLabelsWithVariableData,
  setIsLoading,
  setDisableDateSelection,
  setMinimumDate,
  SetRequiredDate,
  setCustomerRequestDate,
  setPromiseDate,
  setCustomerOrderDate,
  getUserSessionData,
  atLeastOneNull,
  schemaObject2,
  user2,
  csvUplaodEnabled,
  findDistinctValues,
  findDistincPOAndLabel,
  getQuantity,
  checkQuantityFieldName,
  LabPrefix,
  getMessage,
  GetRequesteDate,
  GetRequesteDateAPI,
  schema_name,
  divisionId,
  store_grp,
  setOpenDialog,
  GetSystemParameterValueByName,
  setCsvUplaodEnabled,
  lockDates,
  priorityId,
  setSnackbarMessage,
  setOpenSnackbar,
}) {
  try {
    window.scrollTo(0, 0);
    let firstPageID= JSON.parse(localStorage.getItem("firstPageID"))!==null? JSON.parse(localStorage.getItem("firstPageID")): searchParams.get("PageID");
        await getUserSessionData(
      user_id,
      searchParams.get("OCC") ? getSessionObjectId(searchParams, labelSessionArray) : firstPageID
            ).then(async (data2) => {
      for (var key in data2) {
        sessionCache.set(key, data2[key]);
      }
      var saveLabelSessionValue;
      const normalizeLabelValue = (value) => {
        if (typeof value !== "string") return "";
        const text = value.trim();
        if (!text) return "";
        const parts = text.split("[");
        return (parts[0] || "").trim();
      };
      const getLabelRefFromEntry = (entry) => {
        if (typeof entry === "string") return normalizeLabelValue(entry);
        if (entry && typeof entry === "object") {
          return (
            normalizeLabelValue(entry.labelRef) ||
            normalizeLabelValue(entry.LabelReference) ||
            normalizeLabelValue(entry.label)
          );
        }
        return "";
      };
      const labelsFromParam = (Array.isArray(labelSessionArray) ? labelSessionArray : [])
        .map((element) => {
          if (typeof element === "string") return normalizeLabelValue(element);
          if (element && typeof element === "object") {
            return (
              normalizeLabelValue(element.LabelReference) ||
              normalizeLabelValue(element.labelRef) ||
              normalizeLabelValue(element.label)
            );
          }
          return "";
        })
        .filter((label) => label !== "");
      const labelsFromRedux = Array.isArray(LabelSession2?.LabelSession)
        ? LabelSession2.LabelSession
        : Array.isArray(LabelSession2)
        ? LabelSession2
        : [];
      const metadataByLabelRef = new Map();
      labelsFromRedux.forEach((entry) => {
        if (!entry || typeof entry !== "object") return;
        const labelRef = getLabelRefFromEntry(entry);
        if (!labelRef) return;
        if (entry.fieldName || entry.tagName || entry.prefix) {
          metadataByLabelRef.set(labelRef, {
            ...(entry.fieldName ? { fieldName: entry.fieldName } : {}),
            ...(entry.tagName ? { tagName: entry.tagName } : {}),
            ...(entry.prefix ? { prefix: entry.prefix } : {}),
          });
        }
      });
      const normalizedLabelsFromRedux = labelsFromRedux
        .map((label) => getLabelRefFromEntry(label))
        .filter((label) => label !== "");
      const labelFromUrl = normalizeLabelValue(searchParams.get("label"));
      let firstLabelFromLocal = "";
      try {
        const rawFirstLabel = localStorage.getItem("firstLabel");
        firstLabelFromLocal = rawFirstLabel ? normalizeLabelValue(JSON.parse(rawFirstLabel)) : "";
      } catch (_) {
        firstLabelFromLocal = normalizeLabelValue(localStorage.getItem("firstLabel"));
      }
      let labelEntriesForLookup = labelSessionArray || [];
      // Fallback: derive label entries from sessionArray in localStorage
      if (labelEntriesForLookup.length === 0) {
        try {
          const sa = JSON.parse(localStorage.getItem("sessionArray")) || [];
          const labelListItem = sa.find(item => item.Key === "LabelList");
          if (labelListItem) {
            const parsedData = JSON.parse(labelListItem.Value);
            const occLabelList = parsedData.OCCLabelList || [];
            labelEntriesForLookup = [...new Set(occLabelList.map(item => item.LabelReference))];
          }
        } catch (_) {}
      }
      const labelsFromSessionArray = (Array.isArray(labelEntriesForLookup) ? labelEntriesForLookup : [])
        .map((entry) => {
          if (typeof entry === "string") return normalizeLabelValue(entry);
          if (entry && typeof entry === "object") {
            return (
              normalizeLabelValue(entry.LabelReference) ||
              normalizeLabelValue(entry.labelRef) ||
              normalizeLabelValue(entry.label)
            );
          }
          return "";
        })
        .filter((label) => label !== "");
      if (searchParams.get("OCC")) {
        let newArray = labelSessionArray.map((element) => {
          let parts = element.split("[");
          return parts[0];
        });
       
        saveLabelSessionValue = JSON.parse(
          JSON.stringify({ LabelSession: newArray })
        );
      } else {
        const _suKey =
          "SU" +
          (JSON.parse(localStorage.getItem("firstPageID")) !== null
            ? JSON.parse(localStorage.getItem("firstPageID"))
            : searchParams.get("PageID")) +
          user_id +
          "saveUser";
        var LabelsFromLabelSelectionPage = sessionCache.get(_suKey) ?? null;
        if (LabelsFromLabelSelectionPage) {
        const arr = Object.values(LabelsFromLabelSelectionPage);
        labelEntriesForLookup = arr.filter(e => e && typeof e === "string" && e.includes("["));
        let newArray = arr.map((element) => {
          if (typeof element === "string" && element.includes("[")) {
            let parts = element?.split("[");
            return parts[0];
          }
        });
        saveLabelSessionValue = JSON.parse(
          JSON.stringify({ LabelSession: newArray })
        );
        }
      }
      const normalizedSavedLabels = Array.isArray(saveLabelSessionValue?.LabelSession)
        ? saveLabelSessionValue.LabelSession.filter(
            (label) => typeof label === "string" && label.trim() !== ""
          )
        : [];
      const fallbackLabels = [
        ...labelsFromParam,
        ...normalizedLabelsFromRedux,
        ...labelsFromSessionArray,
        firstLabelFromLocal,
        labelFromUrl,
      ].filter((label) => typeof label === "string" && label.trim() !== "");
      // labelsFromParam (from labelSessionArray) is authoritative when it has more entries
      const LabelSession1 = {
        LabelSession:
          labelsFromParam.length > 0
            ? labelsFromParam
            : (normalizedSavedLabels.length > 0
                ? normalizedSavedLabels
                : [...new Set(fallbackLabels)]),
      };
      const initialLabelRefs = Array.isArray(LabelSession1.LabelSession)
        ? LabelSession1.LabelSession.filter(
            (label) => typeof label === "string" && label.trim() !== ""
          )
        : [];
      var allPageObjectData = [];
      var allSaveUserData = [];
var keyArray = [];
      var SOKeys = [];
      var SUKeys = [];
      // Read label→PageID mapping stored during navigation (GetPageID)
      var labelPageIdMap = {};
      try { labelPageIdMap = JSON.parse(window.localStorage.getItem("labelPageIdMap")) || {}; } catch (_e) { /* ignore */ }

      for (const key of sessionCache.keys()) {
        if (key.includes(user_id)) {
          if (key.slice(0, 2) === "SO") SOKeys.push(key);
          if (key.slice(0, 2) === "SU") SUKeys.push(key);
        }
        keyArray.push(key);
      }
      // Also include non-session localStorage keys in keyArray for downstream logic
      for (var i = 0; i < window.localStorage.length; i++) {
        const lsKey = window.localStorage.key(i);
        if (!keyArray.includes(lsKey)) keyArray.push(lsKey);
      }

      if (atLeastOneNull(LabelSession1.LabelSession)) {
        // Try sessionObjectId (label type) first — matches save path — then PageID
        const sessionObjId = getSessionObjectId(searchParams, labelEntriesForLookup);
        var SOkey = SOKeys.find((element) =>
          element.includes(
            "SO" + sessionObjId + user_id + "saveSchemaObject"
          )
        );
        if (!SOkey && sessionObjId !== firstPageID) {
          SOkey = SOKeys.find((element) =>
            element.includes(
              "SO" + firstPageID + user_id + "saveSchemaObject"
            )
          );
        }
        var SUkey = SUKeys.find((element) =>
          element.includes(
            "SU" + sessionObjId + user_id + "saveUser"
          )
        );
        if (!SUkey && sessionObjId !== firstPageID) {
          SUkey = SUKeys.find((element) =>
            element.includes(
              "SU" + firstPageID + user_id + "saveUser"
            )
          );
        }
        if (true) {
          var t = sessionCache.get(SOkey) ?? null;
          if (t !== null) {
            allPageObjectData.push(t[t.length - 1]);
          }
        }
        if (true) {
          var t = sessionCache.get(SUkey) ?? null;
          if (t !== null) {
            allSaveUserData.push(t);
}
        }
      } else {
        // Build a filtered array of valid label values, then set state once
        let validLabels = [];
        const pushedSOKeys = new Set();
        const pushedSUKeys = new Set();
        for (var i = 0; i < LabelSession1.LabelSession.length; i++) {
          const labelName = LabelSession1.LabelSession[i];
          const labelType = getLabelTypeForSession(labelName, labelEntriesForLookup);
          var SOkey = SOKeys.find((element) =>
            element.includes(
              "SO" +
                (labelType || labelName) +
                user_id +
                "saveSchemaObject"
            )
          );
          // Fallback: try label name if label type key not found
          if (!SOkey && labelType) {
            SOkey = SOKeys.find((element) =>
              element.includes("SO" + labelName + user_id + "saveSchemaObject")
            );
          }
          // Fallback: use label→PageID map from navigation
          var labelPageId = labelPageIdMap[labelName];
          if (!SOkey && labelPageId) {
            SOkey = SOKeys.find((element) =>
              element.includes("SO" + labelPageId + user_id + "saveSchemaObject")
            );
          }
          // Fallback: try checkout URL's PageID
          const currentPageID = searchParams.get("PageID");
          if (!SOkey && currentPageID) {
            SOkey = SOKeys.find((element) =>
              element.includes("SO" + currentPageID + user_id + "saveSchemaObject")
            );
          }
          // Fallback: try firstPageID (page 1, may have partial data)
          if (!SOkey) {
            SOkey = SOKeys.find((element) =>
              element.includes("SO" + firstPageID + user_id + "saveSchemaObject")
            );
          }
          var SUkey = SUKeys.find((element) =>
            element.includes(
              "SU" + (labelType || labelName) + user_id + "saveUser"
            )
          );
          if (!SUkey && labelType) {
            SUkey = SUKeys.find((element) =>
              element.includes("SU" + labelName + user_id + "saveUser")
            );
          }
          // Fallback: use label→PageID map for SU key
          if (!SUkey && labelPageId) {
            SUkey = SUKeys.find((element) =>
              element.includes("SU" + labelPageId + user_id + "saveUser")
            );
          }
          // Fallback: try checkout URL's PageID for SU key
          if (!SUkey && currentPageID) {
            SUkey = SUKeys.find((element) =>
              element.includes("SU" + currentPageID + user_id + "saveUser")
            );
          }
          // Fallback: try firstPageID for SU key (page 1, partial data)
          if (!SUkey) {
            SUkey = SUKeys.find((element) =>
              element.includes("SU" + firstPageID + user_id + "saveUser")
            );
          }
          if (SOkey) {
            var t = sessionCache.get(SOkey) ?? null;
            if (t !== null) {
              if (!pushedSOKeys.has(SOkey)) {
                pushedSOKeys.add(SOkey);
                allPageObjectData.push(t[t.length - 1]);
              }
              if (LabelSession1.LabelSession[i] !== undefined && LabelSession1.LabelSession[i] !== null) {
                validLabels.push(LabelSession1.LabelSession[i]);
              }
            }
          }
          if (SUkey) {
            var t = sessionCache.get(SUkey) ?? null;
            if (t !== null && !pushedSUKeys.has(SUkey)) {
              pushedSUKeys.add(SUkey);
              allSaveUserData.push(t);
            }
          }
        }
        setLabelsWithVariableData(validLabels);

        // When all labels resolved to the same SU key (dedup removed duplicates),
        // load ALL remaining SU data pages so the tempArr loop can find all labels' data.
        if (allSaveUserData.length < validLabels.length) {
          for (var allSi = 0; allSi < SUKeys.length; allSi++) {
            if (pushedSUKeys.has(SUKeys[allSi])) continue;
            try {
              var suAllData = sessionCache.get(SUKeys[allSi]) ?? null;
              if (!suAllData) continue;
              var suAllVals = Object.values(suAllData);
              // Skip label-selection pages (string values with "[")
              if (suAllVals.some(function(v) { return typeof v === "string" && v.includes("["); })) continue;
              // Only include pages with table data
              if (suAllVals.some(function(v) { return Array.isArray(v) && v.length > 0; })) {
                pushedSUKeys.add(SUKeys[allSi]);
                allSaveUserData.push(suAllData);
              }
            } catch (_) {}
          }
        }
      }

      let schemaObject1 =
        allPageObjectData.length > 0 ? allPageObjectData : schemaObject2;
      // Normalize: Redux schemaObject2 is a flat array of field objects,
      // but the code below expects array-of-arrays. Wrap if needed.
      if (Array.isArray(schemaObject1) && schemaObject1.length > 0 && !Array.isArray(schemaObject1[0])) {
        schemaObject1 = [schemaObject1];
      }
      const user1 = allSaveUserData.length > 0 ? allSaveUserData : user2;
      setSchemaObject(schemaObject1);
      setUser(user1);
      let tempArr = [];
      let lineNo = 1;
      var labelFieldsInsideTable = [];
      var labelFields = [];
      var Labels;
      var QuantityFieldName;
      var quantityFieldName = "";
      var tableName;
      var labelRefFieldName;
      var labelRefTableName;
      var hasOrderDetails1 = false;
      if (Array.isArray(schemaObject1[0])) {
      labelFieldsInsideTable = schemaObject1[0]
        .filter((x) => x?.prefix == "TAB"|| x?.prefix == "CTB")
        .map((x) => x?.schemaPageSubItems);
      if (labelFieldsInsideTable.length > 0) {
        Labels = labelFieldsInsideTable[0]
          .filter((x) => x.prefix == LabPrefix)
          .map((x) => x.fieldName);
        QuantityFieldName = labelFieldsInsideTable[0]
          .filter((x) => x.prefix == "QTY")
          .map((x) => x.fieldName);
      }
      labelFields = schemaObject1[0]
        .filter((x) => x.prefix == LabPrefix)
        .map((x) => x.fieldName);
      const quantityResults = checkQuantityFieldName(schemaObject1);
      [quantityFieldName, tableName] = quantityResults;
      // Resolve label ref field within tables (by tagName/LabPrefix)
      [labelRefFieldName, labelRefTableName] = checkLabelRefFieldName(
        schemaObject1,
        LabPrefix
      );
      let sumqty = 0;
      if (quantityFieldName?.length > 0) {
        for (const usr of user1) {
          if (typeof usr[quantityFieldName] === "string") {
            sumqty += parseInt(usr[quantityFieldName]);
          } else if (typeof usr[tableName] === "object") {
            usr[tableName]?.forEach((x) => {
              if (x[quantityFieldName]?.length > 0) {
                sumqty += parseInt(x[quantityFieldName]);
              }
            });
          }
        }
      }
      for (const [key, value] of Object.entries(user1[0])) {
        if (Array.isArray(value) && labelFieldsInsideTable.length > 0) {
          const hasMatchingKey = value.some((entry) =>
            Object.keys(entry).includes(Labels[0])
          );
          if (labelFieldsInsideTable.length > 0 && hasMatchingKey) {
            if (Array.isArray(value)) {
              const sumByOrderNo = value.reduce((acc, obj) => {
                const orderNo = csvUplaodEnabled
                  ? obj["ORDER Nº"]
                  : obj[Labels];
                const quality = parseInt(obj[QuantityFieldName]);
                acc[orderNo] = (acc[orderNo] || 0) + quality;
                return acc;
              }, {});

              const distinctLabels = findDistinctValues(value, Labels);
              const distinctPO1 = findDistinctValues(value, "ORDER Nº");
              const distLabelAndPO = findDistincPOAndLabel(
                value,
                "ORDER Nº",
                Labels
              );
              if (csvUplaodEnabled) {
                for (let i = 0; i < distLabelAndPO.length; i++) {
                  tempArr.push({
                    LineNo: lineNo.toString().padStart(4, "0"),
                    ProductDesc: distLabelAndPO[i].LabelReference,
                    Quantity: sumByOrderNo[distLabelAndPO[i].PONumber],
                    PO: distLabelAndPO[i].PONumber,
                    LabelInsideTable: hasMatchingKey,
                    TableName: key,
                    LabelFieldName: Labels[0],
                    QuantityFieldName: QuantityFieldName,
                  });
                  lineNo++;
                }
              } else {
                if (distinctLabels.length > 0) {
                  for (let i = 0; i < distinctLabels.length; i++) {
                    tempArr.push({
                      LineNo: lineNo.toString().padStart(4, "0"),
                      ProductDesc: distinctLabels[i],
                      Quantity: sumByOrderNo[distinctLabels[i]],
                      PO: distinctPO1[i],
                      LabelInsideTable: hasMatchingKey,
                      TableName: key,
                      LabelFieldName: Labels[0],
                      QuantityFieldName: QuantityFieldName,
                    });
                    lineNo++;
                  }
                }
              }
            }
          } else {
            if (labelFieldsInsideTable.length > 0 && !hasMatchingKey) {
              if (Array.isArray(value)) {
                var TableItemID = schemaObject1[0]
                  .filter((x) => x.fieldName.toString() === key)
                  .map((x) => x.itemId);

                const sumByOrderNo = value.reduce((acc, obj) => {
                  const orderNo = obj["ORDER Nº"];
                  const quality = parseInt(obj[QuantityFieldName]);
                  acc[orderNo] = (acc[orderNo] || 0) + quality;
                  return acc;
                }, {});

                const distinctLabels = findDistinctValues(value, Labels);
                const distinctPO1 = findDistinctValues(value, "ORDER Nº");
                for (let i = 0; i < distinctPO1.length; i++) {
                  var pageName = "";
                  var selectedLabelMappedItemID = "";
                  for (const [key, value2] of Object.entries(user1[0])) {
                    if (!Array.isArray(value2)) {
                      if (
                        labelFields.includes(key) &&
                        value2 != "" &&
                        value2 != "NO"
                      ) {
                        if (value2.includes("[")) {
                          var selectedLabel = value2.split("[");
                          pageName =
                            selectedLabel.length > 1
                              ? selectedLabel[0].replace("]", "")
                              : selectedLabel;
                        } else {
                          pageName = value2;
                        }

                        var selectedLabelValidationData = schemaObject1[0]
                          .filter((x) => x.fieldName.toString() === key)
                          .map((x) => x.validation);

                        const partWithDropdownValue =
                          selectedLabelValidationData[0].LableTableMapPart.split(
                            "|"
                          ).find((part) => part.startsWith(pageName));

                        selectedLabelMappedItemID = partWithDropdownValue
                          ? partWithDropdownValue.split("#")[1]
                          : null;
                      }
                    }
                  }

                  if (selectedLabelMappedItemID === TableItemID.toString()) {
                    tempArr.push({
                      LineNo: lineNo.toString().padStart(4, "0"),
                      ProductDesc: pageName,
                      Quantity: sumByOrderNo[distinctPO1[i]],
                      PO: distinctPO1[i],
                      LabelInsideTable: hasMatchingKey,
                      TableName: key,
                      LabelFieldName: Labels[0],
                      QuantityFieldName: QuantityFieldName,
                    });
                    lineNo++;
                  }
                }
              }
            }
          }
        } else {
          if (
            labelFields.includes(key) &&
            value != "" &&
            value != "NO" &&
            !csvUplaodEnabled
          ) {
            if (value.includes("[")) {
              var selectedLabel = value.split("[");
              var pageName =
                selectedLabel.length > 1
                  ? selectedLabel[0].replace("]", "")
                  : selectedLabel;
            } else {
              var pageName = value;
            }

            if (Array.isArray(value)) {
              value.forEach((val, index) => {
                tempArr.push({
                  LineNo: lineNo.toString().padStart(4, "0"),
                  ProductDesc: val,
                  Quantity: sumqty,
                });
                lineNo++;
              });
            } else {
              tempArr.push({
                LineNo: lineNo.toString().padStart(4, "0"),
                ProductDesc: pageName,
                Quantity: sumqty,
              });
              lineNo++;
            }
          }
        }
      }

      // Process remaining user entries (user1[1], user1[2], ...) for labels not yet in tempArr
      const existingProductDescs = new Set(tempArr.map(e => e.ProductDesc));
      for (let ui = 1; ui < user1.length; ui++) {
        for (const [entryKey, entryVal] of Object.entries(user1[ui])) {
          if (Array.isArray(entryVal) && labelFieldsInsideTable.length > 0) {
            const hasLabel = entryVal.some((entry) =>
              Object.keys(entry).includes(Labels[0])
            );
            if (hasLabel) {
              const extraLabels = findDistinctValues(entryVal, Labels);
              const extraSums = entryVal.reduce((acc, obj) => {
                const lbl = obj[Labels];
                const qty = parseInt(obj[QuantityFieldName]);
                acc[lbl] = (acc[lbl] || 0) + (isNaN(qty) ? 0 : qty);
                return acc;
              }, {});
              for (let i = 0; i < extraLabels.length; i++) {
                if (!existingProductDescs.has(extraLabels[i])) {
                  existingProductDescs.add(extraLabels[i]);
                  tempArr.push({
                    LineNo: lineNo.toString().padStart(4, "0"),
                    ProductDesc: extraLabels[i],
                    Quantity: extraSums[extraLabels[i]] || 0,
                    LabelInsideTable: true,
                    TableName: entryKey,
                    LabelFieldName: Labels[0],
                    QuantityFieldName: QuantityFieldName,
                  });
                  lineNo++;
                }
              }
            }
          }
        }
      }

      hasOrderDetails1 =
        schemaObject1[0].filter(
          (x) => x.prefix !== LabPrefix && x.prefix !== "QTY"
        ).length > 0
          ? true
          : false;
      } // end Array.isArray(schemaObject1[0]) guard
      const uniqueLabelRef1Array = sessionCache.get(
        user_id +
          getSessionObjectId(searchParams, labelSessionArray) +
          "uniqueLabelRef1"
      ) ?? null;
      if (uniqueLabelRef1Array?.length > 0) {
        // Build per-label quantity map from the relevant table rows
        const labelKey = labelRefFieldName || (Array.isArray(Labels) ? Labels[0] : undefined);
        const qtyKey = quantityFieldName;
        let tableRows = undefined;
        // Search ALL user entries for the table containing the label key
        for (let ui = 0; ui < user1.length && !tableRows; ui++) {
          if (labelRefTableName && Array.isArray(user1[ui][labelRefTableName])) {
            tableRows = user1[ui][labelRefTableName];
          } else if (tableName && Array.isArray(user1[ui][tableName])) {
            tableRows = user1[ui][tableName];
          } else {
            for (const [k, v] of Object.entries(user1[ui])) {
              if (Array.isArray(v) && labelKey && v.some((entry) => Object.prototype.hasOwnProperty.call(entry, labelKey))) {
                tableRows = v;
                break;
              }
            }
          }
        }
        // Also accumulate rows from other user entries to ensure all labels are counted
        if (tableRows && user1.length > 1) {
          const allRows = [...tableRows];
          for (let ui = 0; ui < user1.length; ui++) {
            const candidateTable = user1[ui][labelRefTableName] || user1[ui][tableName];
            if (Array.isArray(candidateTable) && candidateTable !== tableRows) {
              candidateTable.forEach(row => {
                if (labelKey && row[labelKey] && !allRows.some(r => r === row)) {
                  allRows.push(row);
                }
              });
            }
          }
          tableRows = allRows;
        }

        const sumByLabel = {};
        if (Array.isArray(tableRows) && labelKey && qtyKey) {
          tableRows.forEach((row) => {
            const lbl = row[labelKey];
            const qv = row[qtyKey];
            if (lbl && qv !== undefined && qv !== "") {
              const qn = parseInt(qv);
              if (!isNaN(qn)) {
                sumByLabel[lbl] = (sumByLabel[lbl] || 0) + qn;
              }
            }
          });
        }

        // Push a line per distinct label from uniqueLabelRef1Array with its summed qty
        // Skip labels already in tempArr to avoid duplicates
        const labelsAlreadyInTempArr = new Set(tempArr.map(e => e.ProductDesc));
        uniqueLabelRef1Array.forEach((value) => {
          if (labelsAlreadyInTempArr.has(value)) return;
          const qty = sumByLabel[value] || 0;
          tempArr.push({
            LineNo: lineNo.toString().padStart(4, "0"),
            ProductDesc: value,
            Quantity: qty,
            PO: undefined,
            LabelInsideTable: !!tableRows,
            TableName: labelRefTableName || tableName,
            LabelFieldName: labelKey,
            QuantityFieldName: quantityFieldName,
          });
          lineNo++;
        });
      }

      if (tempArr.length === 0) {
        if (LabelSession1.LabelSession) {
          for (const session of LabelSession1.LabelSession) {
            if (session) {
              const sessionType = getLabelTypeForSession(session, labelEntriesForLookup);
              var SUkey = SUKeys.find((element) =>
                element.includes("SU" + (sessionType || session) + user_id + "saveUser")
              );
              if (!SUkey && sessionType) {
                SUkey = SUKeys.find((element) =>
                  element.includes("SU" + session + user_id + "saveUser")
                );
              }
              // Fallback: use label→PageID map from navigation
              if (!SUkey && labelPageIdMap[session]) {
                SUkey = SUKeys.find((element) =>
                  element.includes("SU" + labelPageIdMap[session] + user_id + "saveUser")
                );
              }
              // Fallback: try checkout URL's PageID for SU key
              if (!SUkey) {
                const currentPageID = searchParams.get("PageID");
                if (currentPageID) {
                  SUkey = SUKeys.find((element) =>
                    element.includes("SU" + currentPageID + user_id + "saveUser")
                  );
                }
              }
              // Fallback: try firstPageID for SU key (page 1, partial data)
              if (!SUkey) {
                SUkey = SUKeys.find((element) =>
                  element.includes("SU" + firstPageID + user_id + "saveUser")
                );
              }
              // For schema/user, fall back to first schema and last user entry
              // when lineNo exceeds available entries (multi-page mismatch)
              const schemaIdx = schemaObject1[lineNo - 1] !== undefined ? lineNo - 1 : 0;
              const userIdx = user1[lineNo - 1] !== undefined ? lineNo - 1 : user1.length - 1;
              const schemaEntry = schemaObject1[schemaIdx];
              const userEntry = user1[userIdx];
              if (SUkey !== undefined && searchParams.get("OCC")) {
                if (schemaEntry !== undefined) {
                  tempArr.push({
                    LineNo: lineNo.toString().padStart(4, "0"),
                    ProductDesc: session?.labelRef ?? session ?? "",
                    Quantity: Array.isArray(schemaEntry)
                      ? getQuantity(
                          schemaEntry,
                          userEntry,
                          schemaObject1
                        )
                      : 0,
                  });
                  lineNo++;
                }
              } else if (searchParams.get("OCC") && schemaEntry !== undefined && userEntry !== undefined) {
                // OCC fallback: no SU key in localStorage but data available via Redux
                tempArr.push({
                  LineNo: lineNo.toString().padStart(4, "0"),
                  ProductDesc: session?.labelRef ?? session ?? "",
                  Quantity: Array.isArray(schemaEntry)
                    ? getQuantity(
                        schemaEntry,
                        userEntry,
                        schemaObject1
                      )
                    : 0,
                });
                lineNo++;
              } else if (!searchParams.get("OCC")) {
                tempArr.push({
                  LineNo: lineNo.toString().padStart(4, "0"),
                  ProductDesc: session?.labelRef ?? session ?? "",
                  Quantity: Array.isArray(schemaEntry)
                    ? getQuantity(
                        schemaEntry,
                        userEntry,
                        schemaObject1
                      )
                    : 0,
                });
                lineNo++;
              }
            }
          }
        }
      }

      // Final safeguard: if labels are selected but no rows were reconstructed,
      // build minimal rows so downstream date logic does not treat it as no label selection.
      if (tempArr.length === 0) {
        const selectedLabels = (LabelSession1?.LabelSession || [])
          .filter((label) => typeof label === "string" && label.trim() !== "")
          .map((label) => {
            const parts = label.split("[");
            return (parts[0] || "").trim();
          })
          .filter((label) => label !== "");
        const uniqueSelectedLabels = [...new Set(selectedLabels)];
        uniqueSelectedLabels.forEach((label, idx) => {
          tempArr.push({
            LineNo: (idx + 1).toString().padStart(4, "0"),
            ProductDesc: label,
            Quantity: 0,
          });
        });
      }

      // EPK implied item: when store_grp is "EPK", check if any product
      // description requires an implied item and append it with the same qty
      if (store_grp === "EPK") {
        try {
          const impliedItemData = await GetSystemParameterValueByNameTextFormat(
            "React_EPK_RequiresImpliedItem"
          );
          let requiredProductDescs = [];
          if (typeof impliedItemData === "string") {
            requiredProductDescs = impliedItemData
              .split("|")
              .map((s) => s.trim())
              .filter(Boolean);
          } else if (Array.isArray(impliedItemData)) {
            requiredProductDescs = impliedItemData
              .map((item) =>
                typeof item === "string"
                  ? item
                  : item?.value || item?.name || ""
              )
              .filter(Boolean);
          }

          const matchingItems = tempArr.filter((item) =>
            requiredProductDescs.includes(item.ProductDesc)
          );

          for (const matchItem of matchingItems) {
            const impliedLabelData = await GetSystemParameterValueByNameTextFormat(
              `React_EPK_impliedItem_${matchItem.ProductDesc}`
            );
            let impliedLabels = [];
            if (typeof impliedLabelData === "string") {
              impliedLabels = impliedLabelData
                .split("|")
                .map((s) => s.trim())
                .filter(Boolean);
            } else if (
              Array.isArray(impliedLabelData) &&
              impliedLabelData.length > 0
            ) {
              impliedLabels = impliedLabelData
                .map((item) =>
                  typeof item === "string"
                    ? item.trim()
                    : (item?.value || item?.name || "").trim()
                )
                .filter(Boolean);
            }

            for (const impliedLabel of impliedLabels) {
              const nextLineNo = tempArr.length + 1;
              tempArr.push({
                LineNo: nextLineNo.toString().padStart(4, "0"),
                ProductDesc: impliedLabel,
                Quantity: matchItem.Quantity,
                isImpliedItem: true,
              });
            }
          }

          // EPK overage: fetch product descriptions requiring overage and apply % from IMPLIEDOVG field
          const overageData = await GetSystemParameterValueByNameTextFormat(
            "REACT_EPK_Overage"
          );
          let overageProductDescs = [];
          if (typeof overageData === "string") {
            overageProductDescs = overageData
              .split("|")
              .map((s) => s.trim())
              .filter(Boolean);
          } else if (Array.isArray(overageData)) {
            overageProductDescs = overageData
              .map((item) =>
                typeof item === "string" ? item : item?.value || item?.name || ""
              )
              .filter(Boolean);
          }

          if (overageProductDescs.length > 0) {
            // Find the IMPLIEDOVG field value from schema/user data
            let overagePercent = 0;
            for (let si = 0; si < schemaObject1.length; si++) {
              const schemaPage = schemaObject1[si];
              if (!Array.isArray(schemaPage)) continue;
              // Check top-level fields
              const ovgField = schemaPage.find(
                (f) => f && f.tagName === "IMPLIEDOVG"
              );
              if (ovgField && user1[si]) {
                const val = parseFloat(user1[si][ovgField.fieldName]);
                if (!isNaN(val)) {
                  overagePercent = val;
                  break;
                }
              }
              // Check inside table sub-items
              for (const field of schemaPage) {
                if (!field?.schemaPageSubItems) continue;
                const subOvg = field.schemaPageSubItems.find(
                  (sub) => sub && sub.tagName === "IMPLIEDOVG"
                );
                if (subOvg && user1[si]) {
                  const tableData = user1[si][field.fieldName];
                  if (Array.isArray(tableData) && tableData.length > 0) {
                    const val = parseFloat(tableData[0][subOvg.fieldName]);
                    if (!isNaN(val)) {
                      overagePercent = val;
                      break;
                    }
                  }
                }
              }
              if (overagePercent > 0) break;
            }

            // Apply overage to matching implied items
            if (overagePercent > 0) {
              tempArr.forEach((item) => {
                if (
                  item.isImpliedItem &&
                  overageProductDescs.includes(item.ProductDesc)
                ) {
                  const baseQty = parseInt(item.Quantity) || 0;
                  const overageAmount = Math.floor(
                    baseQty * (overagePercent / 100)
                  );
                  item.Quantity = baseQty + overageAmount;
                }
              });
            }
          }
        } catch (err) {
          console.error("Error fetching EPK implied item data:", err);
        }
      }

      setNewtempArr(tempArr);
      if (tempArr.length === 0) {
        const normalizeFinalLabel = (value) => {
          if (typeof value !== "string") return "";
          const parts = value.split("[");
          return (parts[0] || "").trim();
        };
        const fallbackLabelsSet = new Set(
          (LabelSession1?.LabelSession || [])
            .map((label) => normalizeFinalLabel(label))
            .filter((label) => label !== "")
        );
        uniqueLabelRef1Array.forEach((label) => {
          const normalized = normalizeFinalLabel(label);
          if (normalized) fallbackLabelsSet.add(normalized);
        });
        if (normalizeFinalLabel(searchParams.get("label"))) {
          fallbackLabelsSet.add(normalizeFinalLabel(searchParams.get("label")));
        }
        try {
          const rawFirstLabel = localStorage.getItem("firstLabel");
          const fromLocal = rawFirstLabel
            ? normalizeFinalLabel(JSON.parse(rawFirstLabel).toString())
            : "";
          if (fromLocal) fallbackLabelsSet.add(fromLocal);
        } catch (_) {
          const fromLocal = normalizeFinalLabel((localStorage.getItem("firstLabel") || "").toString());
          if (fromLocal) fallbackLabelsSet.add(fromLocal);
        }

        const fallbackLabels = Array.from(fallbackLabelsSet);
        if (fallbackLabels.length > 0) {
          tempArr.length = 0;
          fallbackLabels.forEach((label, idx) => {
            tempArr.push({
              LineNo: (idx + 1).toString().padStart(4, "0"),
              ProductDesc: label,
              Quantity: 0,
            });
          });
          setLabelsWithVariableData(fallbackLabels);
        }
        setNewtempArr(tempArr);
      }

      const labelSchemaForSession = Array.isArray(schemaObject1[0])
        ? schemaObject1[0].find(
            (field) => field?.prefix === LabPrefix && field?.multiSelect === false
          ) ?? schemaObject1[0]
              .flatMap((field) =>
                Array.isArray(field?.schemaPageSubItems)
                  ? field.schemaPageSubItems
                  : []
              )
              .find(
                (field) =>
                  field?.prefix === LabPrefix ||
                  field?.tagName === "LABELREF" ||
                  field?.tagName === "LABEL"
              )
        : undefined;

      const labelRefsFromTempArr = [...new Set(
        tempArr
          .map((item) => item?.ProductDesc)
          .filter((label) => typeof label === "string" && label.trim() !== "")
      )];

      const labelRefsForSession =
        labelRefsFromTempArr.length > 0 ? labelRefsFromTempArr : initialLabelRefs;

      setLabelSession({
        LabelSession: labelRefsForSession.map((labelRef) => {
          const labelMeta = metadataByLabelRef.get(labelRef);
          return {
            labelRef,
            ...(labelMeta?.fieldName
              ? { fieldName: labelMeta.fieldName }
              : labelSchemaForSession?.fieldName
              ? { fieldName: labelSchemaForSession.fieldName }
              : {}),
            ...(labelMeta?.tagName
              ? { tagName: labelMeta.tagName }
              : labelSchemaForSession?.tagName
              ? { tagName: labelSchemaForSession.tagName }
              : {}),
            ...(labelMeta?.prefix
              ? { prefix: labelMeta.prefix }
              : labelSchemaForSession?.prefix
              ? { prefix: labelSchemaForSession.prefix }
              : {}),
          };
        }),
      });

      GetRequesteDate(tempArr, {
        divisionId,
        store_grp,
        setIsLoading,
        alert: window.alert,
        getMessage,
        setDisableDateSelection,
        setMinimumDate,
        SetRequiredDate,
        setCustomerRequestDate,
        setPromiseDate,
        setCustomerOrderDate,
        GetRequesteDateAPI,
        lockDates,
        priorityId,
        setSnackbarMessage,
        setOpenSnackbar,
      });
      setOpenDialog(hasOrderDetails1);
      await GetSystemParameterValueByName(
        "REACT_APP_CSV_UPLOAD_ENABLED_SCHEMAS"
      ).then((data) => {
        setCsvUplaodEnabled(
          data.some((item) => item.schemaName === schema_name)
        );
      });
    });
  } catch (error) {
    console.error("Error fetching user session data:", error);
  }
}

// helper to keep date-only (preserve chosen calendar day)
function toUTCDateOnly(dateVal) {
  if (!dateVal) return "";
  const d = new Date(dateVal);
  const utcMidnight = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  return utcMidnight.toISOString().split(".")[0]; // YYYY-MM-DDTHH:mm:ss
}

// Extract catalogue catId from schema: prefer CTB item subitems' catId, then item's own catId
export function getSchemaCatIdFromSchema(schemaObj) {
  try {
    const pages = Array.isArray(schemaObj) ? schemaObj : [];
    for (const page of pages) {
      const items = Array.isArray(page) ? page : [];
      for (const item of items) {
        if (!item || item.prefix !== "CTB") continue;
        if (typeof item.catId === "number" && item.catId > 0) return item.catId;
        const subs = Array.isArray(item.schemaPageSubItems) ? item.schemaPageSubItems : [];
        const found = subs.find((si) => si && typeof si.catId === "number" && si.catId > 0);
        if (found) return found.catId;
      }
    }
  } catch (_) {}
  return null;
}

// Derive CAT key values (key1, key2, key3) from schema and user data
// Only consider fields where visible === true for visibility gating
export function deriveCatKeysFromSchema(schemaObj, userObjs) {
  let k1 = "";
  let k2 = "";
  let k3 = "";
  try {
    const pages = Array.isArray(schemaObj) ? schemaObj : [];
    const users = Array.isArray(userObjs) ? userObjs : [];
    const getFieldValue = (fieldName, parentTableName) => {
      if (!fieldName) return "";
      for (const u of users) {
        if (!u || typeof u !== "object") continue;
        if (parentTableName && Array.isArray(u[parentTableName])) {
          for (const row of u[parentTableName]) {
            const rv = row?.[fieldName];
            if (rv !== undefined && rv !== null && String(rv) !== "") return rv;
          }
        } else {
          const v = u[fieldName];
          if (v !== undefined && v !== null && String(v) !== "") return v;
        }
      }
      return "";
    };
    for (const page of pages) {
      const items = Array.isArray(page) ? page : [];
      for (const item of items) {
        // Top-level CAT (visible via `visible`)
        if (item && item.prefix === "CAT" && item.visible === true) {
          const idx = Number(item.keyIndex);
          const val = getFieldValue(item.fieldName);
          if (idx === 1 && !k1 && val) k1 = val;
          if (idx === 2 && !k2 && val) k2 = val;
          if (idx === 3 && !k3 && val) k3 = val;
          if (k1 && k2 && k3) return { k1, k2, k3 };
        }
        // CAT within TAB/CTB
        if (item && (item.prefix === "TAB" || item.prefix === "CTB") && Array.isArray(item.schemaPageSubItems)) {
          for (const sub of item.schemaPageSubItems) {
            // Consider subitem visibility via `visible`
            if (sub && sub.prefix === "CAT" && sub.visible === true) {
              const sIdx = Number(sub.keyIndex);
              const sVal = getFieldValue(sub.fieldName, item.fieldName);
              if (sIdx === 1 && !k1 && sVal) k1 = sVal;
              if (sIdx === 2 && !k2 && sVal) k2 = sVal;
              if (sIdx === 3 && !k3 && sVal) k3 = sVal;
              if (k1 && k2 && k3) return { k1, k2, k3 };
            }
          }
        }
      }
    }
  } catch (_) {}
  return { k1, k2, k3 };
}
